import styled from 'styled-components';

export const Toolbar = styled.div`
  margin-bottom: 1em;

  h1,
  h2,
  h3 {
    display: inline-block;
  }

  input,
  button {
    float: right;
    margin-left: 0.5em;
  }
`;
